import { type SvgComponentType } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  eventTypes,
  objectTypes,
  useTracker,
} from "@newsela/snitch";

import { reportsMenuPopoutContainer } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ReportsMenu/ReportsMenuPopout/ReportsMenuPopout.styles";
import { useGetReportsMenuSectionProps } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/hooks/useGetReportsMenuSectionProps/useGetReportsMenuSectionProps";
import { PopoutMenuSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection";
import { PopoutSectionItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItem";
import getEntityForUserRole from "@/reports/utils/getEntityForUserRole";
import { User } from "@/types/models";

interface Props {
  user: User;
}

const ReportsMenuPopout = ({ user }: Props) => {
  const { reportsMenuSectionTitle, reportsMenuSectionItems } =
    useGetReportsMenuSectionProps();
  const { trackAction, getEventName } = useTracker();

  const { entityId, entityType } = getEntityForUserRole(user);

  const handleItemClick = (title: string) => {
    trackAction({
      event_name: getEventName(
        objectTypes.user,
        actionPrefixes.initiate,
        actionNames.navigate,
      ),
      event_type: eventTypes.click,
      dimension_properties: {
        description: `Navigates to ${title} page using the global nav menu."`,
        metadata: {
          entityId,
          entityType,
          userRoles: user.roles,
        },
      },
    });
  };

  return (
    <div css={reportsMenuPopoutContainer}>
      <PopoutMenuSection width="20rem" title={reportsMenuSectionTitle}>
        {reportsMenuSectionItems.map(
          ({ title, href, SvgComponent, dataQASelector }, index) => (
            <PopoutSectionItem
              key={index}
              href={href}
              title={title}
              SvgComponent={SvgComponent as SvgComponentType}
              dataQASelector={dataQASelector}
              onClick={handleItemClick}
            />
          ),
        )}
      </PopoutMenuSection>
    </div>
  );
};

ReportsMenuPopout.displayName = "ClassesMenuPopout";
export { ReportsMenuPopout };
